import React from "react";

import { Modal, ModalBody, modalConnect } from "@modal";

const ModalConfirmation = modalConnect((props) => {
  return (
    <Modal
      title={props.title}
      onSave={props.save_action && (() => props.dispatch(props.save_action))}
      saveText={props.save_text}
      dangerous={props.dangerous}
      onCancel={
        props.cancel_action && (() => props.dispatch(props.cancel_action))
      }
      cancelText={props.cancel_text}
    >
      <ModalBody>{props.warning}</ModalBody>
    </Modal>
  );
});

export default ModalConfirmation;
